import React, { useState, useEffect } from 'react'
import { Container, Button, Grid, Typography, Checkbox, FormControlLabel, Snackbar } from "@mui/material"
import makeStyles from "@mui/styles/makeStyles"
import { useConfirmationDialog } from '../providers/ConfirmationDialogProvider';

const useStyles = makeStyles({

})

export default function EditEmail(props) {
    const { openConfirmationDialog } = useConfirmationDialog();

    const classes = useStyles();
    const [emailRoleList, setEmailRoleList] = useState({
        acionamentos: props.email.acionamentos,
        disparos: props.email.disparos,
        removidos: props.email.removidos,
        bateria: props.email.bateria,
        alarmes: props.email.alarmes,
        reset: props.email.reset
    })


    const [disabled, setDisabled] = useState()
    const { acionamentos, disparos, removidos, bateria, alarmes, reset } = emailRoleList

    const handleRoles = (event) => {
        setEmailRoleList({
            ...emailRoleList,
            [event.target.name]: event.target.checked,
        })
    }

    const handleUpdate = async (e) => {
        const updatedEmail = {
            ...props.email,
            acionamentos: emailRoleList.acionamentos,
            disparos: emailRoleList.disparos,
            removidos: emailRoleList.removidos,
            bateria: emailRoleList.bateria,
            alarmes: emailRoleList.alarmes,
            reset: emailRoleList.reset
        };

        await props.editEmail(updatedEmail);
    };

    const handleDelete = () => {
        openConfirmationDialog({
            title: 'Confirmar Exclusão',
            message: `Tem certeza que deseja excluir o destinatário ${props.email.name}?`,
            confirmButtonText: 'Excluir',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: 'error',
            onConfirm: async () => {
                props.setIsLoading(true);
                try {
                    await props.deleteEmail(props.email);
                } finally {
                    props.setIsLoading(false);
                }
            }
        });
    };

    return (
        <Grid container spacing={1}>
            <Grid item xs={12} md={12} lg={12}>
                <FormControlLabel
                    disabled={props.isLoading}
                    control={
                        <Checkbox label="Top" disabled={disabled} checked={acionamentos} onChange={handleRoles} name="acionamentos" />
                    }
                    label="Acionamentos"
                />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <FormControlLabel
                    disabled={props.isLoading}
                    control={
                        <Checkbox label="Top" disabled={disabled} checked={disparos} onChange={handleRoles} name="disparos" />
                    }
                    label="Disparos"
                />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <FormControlLabel
                    disabled={props.isLoading}
                    control={
                        <Checkbox label="Top" disabled={disabled} checked={removidos} onChange={handleRoles} name="removidos" />
                    }
                    label="Removidos"
                />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <FormControlLabel
                    disabled={props.isLoading}
                    control={
                        <Checkbox label="Top" disabled={disabled} checked={bateria} onChange={handleRoles} name="bateria" />
                    }
                    label="Bateria Baixa"
                />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <FormControlLabel
                    disabled={props.isLoading}
                    control={
                        <Checkbox label="Top" disabled={disabled} checked={alarmes} onChange={handleRoles} name="alarmes" />
                    }
                    label="Alarmes"
                />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <FormControlLabel
                    disabled={props.isLoading}
                    control={
                        <Checkbox label="Top" disabled={disabled} checked={reset} onChange={handleRoles} name="reset" />
                    }
                    label="Restaurar central"
                />
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{ display: "flex", justifyContent: "flex-end", marginTop: "15px" }}>
                <Button 
                    onClick={handleDelete} 
                    sx={{ mr: "20px" }} 
                    variant="contained" 
                    disabled={disabled || props.isLoading} 
                    color="error"
                >
                    Excluir
                </Button>
                <Button 
                    onClick={handleUpdate} 
                    variant="contained" 
                    disabled={props.isLoading}
                    color="secondary"
                >
                    Salvar
                </Button>
            </Grid>
        </Grid>
    );
}